module.exports = __webpack_public_path__ + "img/back5.e20760b6.png";